import { CashierSessionSummary } from './CashierSessionSummary';

export class LogoutCashierSummaryDate
{
    startDate:string;
    endDate:string;
    summary:CashierSessionSummary;
}